import React, { useEffect, useState } from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { Get } from "../../../../actions";
import {
    // TODO: Add these to your apiUrls constants file
    // Get_All_Rooms_URL        → GET  /api/rooms
    // Get_All_BlockRules_URL   → GET  /api/block-services
    Get_All_Rooms_URL,
    Get_All_BlockRules_URL,
    Update_BlockRule_URL,
    Create_BlockRule_URL,
} from "../../../../constants/apiUrls";
import { getTranslation } from "../../../../heplers/translationHelper";
import { DayTimeSelection } from "../maxCapacity/dayTimeSelection";
import AddBlockRuleModal from "./Addblockrulemodal";
import BlockRulesTable from "./Blockrulestable";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
    title: {
        fontSize: 20,
        fontWeight: 600,
        color: "#0d4f6c",
    },
    subtitle: {
        fontSize: 13,
        color: "#78909c",
        marginTop: 2,
    },
}));

const BlockServicesTab = () => {
    const classes = useStyles();

    const [rooms, setRooms] = useState([]);
    const [blockRules, setBlockRules] = useState([]);
    const [loadingRooms, setLoadingRooms] = useState(false);
    const [loadingRules, setLoadingRules] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingRule, setEditingRule] = useState(null);

    // ─── fetch rooms ────────────────────────────────────────────────────────
    const fetchRooms = async () => {
        setLoadingRooms(true);
                  await Get(
            {},
            "TableManagement/GetAllAreas",
            null,
            (response) => {
                setLoadingRooms(false)
              setRooms(response.data);
            //   if(response.data.length && !selectedArea)
            //     setSelectedArea(response.data[0])
              // const initialTables = {};
              // response.data.forEach((area) => {
              //   initialTables[area.id] = [];
              // });
              // setTables(initialTables);
            },
            (error) => {
              console.error("Error fetching areas:", error);
                setLoadingRooms(false)
                
            }
          );
        /**
         * TODO — API: GET /api/rooms
         * Response: [{ id, name, totalSeats }]
         * Replace mock below:
         *
         * Get({}, Get_All_Rooms_URL, null, (res) => {
         *   setRooms(res.data);
         *   setLoadingRooms(false);
         * }, () => setLoadingRooms(false));
         */
        // setTimeout(() => {
        //     setRooms([
        //         { id: "1", name: "Main Dining",     totalSeats: 48 },
        //         { id: "2", name: "Private Room A",  totalSeats: 12 },
        //         { id: "3", name: "Rooftop Terrace", totalSeats: 30 },
        //         { id: "4", name: "Garden Area",     totalSeats: 20 },
        //         { id: "5", name: "Bar Lounge",      totalSeats: 16 },
        //     ]);
        //     setLoadingRooms(false);
        // }, 300);
    };

    // ─── fetch block rules ──────────────────────────────────────────────────
    const fetchBlockRules = () => {
            setLoadingRules(true);
    Get(
        {},
        Get_All_BlockRules_URL,
        null,
        (res) => {
            setBlockRules(res.data);
            setLoadingRules(false);
        },
        () => setLoadingRules(false)
    );
        /**
         * TODO — API: GET /api/block-services
         * Response: [{
         *   id, blockType,           // "recurring" | "period" | "date"
         *   dayTime,                 // 0=Morning,1=Afternoon,2=Evening,3=WholeDay
         *   days,                    // [1,2] (used when blockType="recurring")
         *   fromDate, toDate,        // (used when blockType="period")
         *   specificDate,            // (used when blockType="date")
         *   roomIds,                 // [string]
         *   roomNames,               // [string]
         *   reason,
         * }]
         *
         * Replace mock below:
         *
         * Get({}, Get_All_BlockRules_URL, null, (res) => {
         *   setBlockRules(res.data);
         *   setLoadingRules(false);
         * }, () => setLoadingRules(false));
         */
        // setTimeout(() => {
        //     setBlockRules([
        //         {
        //             id: "r1",
        //             blockType: "recurring",
        //             dayTime: 0,
        //             days: [2, 4],
        //             fromDate: null,
        //             toDate: null,
        //             specificDate: null,
        //             roomIds: ["3"],
        //             roomNames: ["Rooftop Terrace"],
        //             reason: "Regular maintenance",
        //         },
        //         {
        //             id: "r2",
        //             blockType: "period",
        //             dayTime: 3,
        //             days: [],
        //             fromDate: "2026-05-01",
        //             toDate: "2026-05-15",
        //             specificDate: null,
        //             roomIds: ["2", "4"],
        //             roomNames: ["Private Room A", "Garden Area"],
        //             reason: "Renovation",
        //         },
        //         {
        //             id: "r3",
        //             blockType: "date",
        //             dayTime: 2,
        //             days: [],
        //             fromDate: null,
        //             toDate: null,
        //             specificDate: "2026-05-20",
        //             roomIds: ["5"],
        //             roomNames: ["Bar Lounge"],
        //             reason: "Private event",
        //         },
        //     ]);
        //     setLoadingRules(false);
        // }, 300);
    };


    useEffect(() => {
        fetchRooms();
        fetchBlockRules();
    }, []);

    // ─── handlers ───────────────────────────────────────────────────────────
    const handleAddRule = () => {
        setEditingRule(null);
        setModalOpen(true);
    };

    const handleEditRule = (rule) => {
        setEditingRule(rule);
        setModalOpen(true);
    };

    const handleRuleSaved = () => {
        fetchBlockRules(); // re-fetch after save
    };

    const handleRuleDeleted = () => {
        fetchBlockRules(); // re-fetch after delete
    };

    return (
        <Box className={classes.root}>

            {/* Rules table */}
            <BlockRulesTable

                blockRules={blockRules}
                loading={loadingRules}
                rooms={rooms}
                onAdd={handleAddRule}
                onEdit={handleEditRule}
                onDeleted={handleRuleDeleted}
            />

            {/* Add / Edit modal */}
            <AddBlockRuleModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                rooms={rooms}
                editingRule={editingRule}
                onSaved={handleRuleSaved}
            />
        </Box>
    );
};

export default BlockServicesTab;